import React, { useEffect } from 'react';

import { userActions, globalActions } from '../../actions';

import { NavLink, Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

function Sidebar() {
  const loggedIn = useSelector(state => state.authentication.loggedIn);
  let classes = loggedIn ? "sidebar sidebar--private" : "sidebar sidebar--public hidden-mobile-tablet"

  return (
    <div className={classes}>
      {loggedIn && <SidebarPrivate />}
    </div>
  );
}

function SidebarPrivate() {
  const dispatch = useDispatch();

  const userAuthent = useSelector(state => state.authentication.user);
  const usersState = useSelector(state => state.users);

  const prenom = usersState.account ? usersState.account.prenom : (userAuthent.data ? userAuthent.data.firstName : '');

  useEffect(() => {
    dispatch(userActions.getAccount());
    dispatch(globalActions.loadCourts());
    dispatch(globalActions.loadConfig());
  }, [dispatch]);

  return (
    <div>
      <strong className="title--h2">Hello {prenom}&nbsp;!</strong>
      <p>Bienvenue dans ton espace perso.<br />N'hésite pas à venir nous voir ou réserve un court directement en ligne&nbsp;!</p>
      {(usersState.account && usersState.account.commentaire) &&
        <div className="bloc-reservation__item no-hover in-sidebar">
          <div>
            <strong>Note de la direction</strong><br />
            {usersState.account.commentaire}
          </div>
        </div>
      }
      <nav role="navigation" className="nav nav--account" id="nav--account">
        <ul className="list--unstyled">
          <li>
            <NavLink exact to="/" activeClassName="active">
              <svg className="icon" aria-hidden="true">
                <use xlinkHref="#icon-15-raquette" />
              </svg>
                Mes réservations
            </NavLink>
          </li>
          <li>
            <NavLink to="/compte" activeClassName="active">
              <svg className="icon" aria-hidden="true">
                <use xlinkHref="#icon-03-carte" />
              </svg>
                Mon compte
            </NavLink>
          </li>
          <Link to="/login" className="btn">
            <svg className="icon" aria-hidden="true">
              <use xlinkHref="#icon-22-deconnexion" />
            </svg>
            Déconnexion
            </Link>
        </ul>
      </nav>
    </div>
  )
}

export default Sidebar;
